import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const currencyUomService = {
  async getCurrencies(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/currency-uom", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveCurrencies() {
    try {
      const response = await apiClient.get("/currency-uom/active");
      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      return {
        items,
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getCurrencyById(id) {
    if (!id) throw new Error("Currency UOM ID is required");

    try {
      const response = await apiClient.get(`/currency-uom/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createCurrency(data) {
    try {
      const response = await apiClient.post("/currency-uom", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateCurrency(id, data) {
    if (!id) throw new Error("Currency UOM ID is required");

    try {
      const response = await apiClient.patch(`/currency-uom/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteCurrency(id) {
    if (!id) throw new Error("Currency UOM ID is required");

    try {
      const response = await apiClient.delete(`/currency-uom/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default currencyUomService;
